import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import FormularioNoVerificado from "./pages/FormularioNoVerificado";
import FormularioFotografo from "./pages/FormularioFotografo";
import AcreditacionesVerificado from "./pages/AcreditacionesVerificado";
import AcreditacionesNoVerificado from "./pages/AcreditacionesNoVerificado";
import AcreditacionesFotografo from "./pages/AcreditacionesFotografo";
import ProtectedRoute from "./pages/ProtectedRoute";
import PartidoRoute from "./pages/PartidoRoute";
import LayoutNoVerificado from "./pages/LayoutNoVerificado";
import LayoutVerificado from "./pages/LayoutVerificado";
import Eventos from "./pages/Eventos";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Eventos />} />
      <Route element={<PartidoRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<LayoutVerificado />}>
            <Route
              path="/acreditaciones/:id"
              element={<AcreditacionesVerificado />}
            />
            <Route
              path="/sumar-acreditaciones/:id"
              element={<AcreditacionesNoVerificado />}
            />
            <Route
              path="/acreditacion-fotografo/:id"
              element={<AcreditacionesFotografo />}
            />
          </Route>
        </Route>
        <Route element={<LayoutNoVerificado />}>
          <Route path="/login/formulario-inicio" element={<FormularioNoVerificado />} />
          <Route path="/login/formulario-fotografo" element={<FormularioFotografo />} />
        </Route>
      </Route>
    </>
  ),
);
